import { Container, Box } from '@mui/material';
import './Header.scss'
import {AppImages} from "../../images";

const { logo } = AppImages;

const Header = () => {
  return (
    <header className="public-header">
      <Container>
        <Box className="d-flex justify-content-between">
        <a
            href={"/"}
            className="logo"
          >
          <img className="logo" src={logo} alt="logo"/>
          </a>
        </Box>
      </Container>
    </header>
  );
};

export default Header;